/** A song to try the app with. Its words and tune are old enough to be free to use. */
export const EXAMPLE_SONG = {
    details: { title: "Amazing Grace", artist: "John Newton" },
    text: `{key: G}

{start_of_verse: Verse 1}
[G]Amazing [G7]grace, how [C]sweet the [G]sound
That [G]saved a wretch like [D]me
I [G]once was [G7]lost, but [C]now am [G]found
Was [Em]blind but [D]now I [G]see
{end_of_verse}

{start_of_verse: Verse 2}
'Twas [G]grace that [G7]taught my [C]heart to [G]fear,
And [G]grace my fears re[D]lieved;
How [G]precious [G7]did that [C]grace ap[G]pear
The [Em]hour I [D]first be[G]lieved.
{end_of_verse}

{start_of_verse: Verse 3}
Through [G]many [G7]dangers, [C]toils and [G]snares
I [G]have already [D]come;
'Tis [G]grace hath [G7]brought me [C]safe thus [G]far,
And [Em]grace will [D]lead me [G]home.
{end_of_verse}

{start_of_verse: Verse 4}
When [G]we've been [G7]there ten [C]thousand [G]years,
Bright [G]shining as the [D]sun,
We've [G]no less [G7]days to [C]sing God's [G]praise
Than [Em]when we'd [D]first be[G]gun.
{end_of_verse}
`,
};
